import React, {lazy, Suspense, useContext, useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import SelectComponent from '../../Selects/SelectComponent';
import moment from 'moment';
import {useHistory, useParams} from 'react-router-dom';

import {getCortesias, getFuncoes, getInteresses, getLead, getLeadStatus, gravarLead} from '../api';
import {Context} from '../../../Helpers/Auth';
import Detalhes from './Detalhes';
import Endereco from './Endereco';
import Spinner from '../../Spinner';
import {toast, ToastContainer} from 'react-toastify';
import {getCategoriasArtigos, getLinguas, getMarcas, getModelos, getMoedas, getNacionaisInternacionais, getOrigens, getPaises, getRepresentantes, getTipos} from '../../../pages/requests';
import ExitForm from '../../ExitFormModal';
import LoadingModal from '../../LoadingModal';

export default function LeadForm({
    leadSelecionado,
    onChangeForm,
    setOnChangeForm,
    setShowForm,
    openTab,

    guardarLead,
    setGuardarLead,

    setEditarLead,
    editarLead,

    novaConta,
    setNovaConta,

    novaReuniaoVisita,
    setNovaReuniaoVisita,
}) {
    const {t} = useTranslation();
    const {userRepresentante} = useContext(Context);
    const history = useHistory();

    let lang;
    switch (localStorage.getItem('i18nextLng')) {
        case 'pt':
            lang = 'POR';
            break;
        case 'fr':
            lang = 'FRA';
            break;
        case 'en':
            lang = 'ENG';
            break;
        case 'es':
            lang = 'ES'; 
            break;
    }

    // Dados para da Lead
    const [lead, setLead] = useState(null);
    const [leadCortesia, setLeadCortesia] = useState(null);
    const [leadNome, setLeadNome] = useState('');
    const [leadApelido, setLeadApelido] = useState('');
    const [leadRazaoSocial, setLeadRazaoSocial] = useState('');
    const [leadFuncao, setLeadFuncao] = useState(null);
    const [leadTelemovel, setLeadTelemovel] = useState('');
    const [leadEmail, setLeadEmail] = useState('');
    const [leadNIF, setLeadNIF] = useState('');
    const [leadOrigem, setLeadOrigem] = useState(null);
    const [leadStatus, setLeadStatus] = useState(null);
    const [leadInteresse, setLeadInteresse] = useState(null);
    const [leadFollowUp, setLeadFollowUp] = useState('');
    const [leadCategoria, setLeadCategoria] = useState(null);
    const [leadMarca, setLeadMarca] = useState(null);
    const [leadNacionalInternacional, setLeadNacionalInternacional] = useState(null);
    const [leadTipo, setLeadTipo] = useState(null);
    const [leadModelo, setLeadModelo] = useState(null);
    const [leadRepresentante, setLeadRepresentante] = useState(userRepresentante);
    // const [leadMoeda, setLeadMoeda] = useState(null);
    const [leadLingua, setLeadLingua] = useState(null);
    const [leadComentario, setLeadComentario] = useState('');
    const [leadMoradas, setLeadMoradas] = useState([
        {
            id: '',
            pais: null,
            morada: '',
            codigoPostal: '',
            cidade: '',
            enderecoDefeito: false,
            descricao: '',
        },
    ]);

    // Encdereços
    const [leadMoradaID, setLeadMoradaID] = useState('');
    const [leadMoradaPais, setLeadMoradaPais] = useState(null);
    const [leadMoradaMorada, setLeadMoradaMorada] = useState('');
    const [leadMoradaCodigoPostal, setLeadMoradaCodigoPostal] = useState('');
    const [leadMoradaCidade, setLeadMoradaCidade] = useState('');
    const [leadMoradaContacto, setLeadMoradaContacto] = useState('');
    const [leadMoradaDescricao, setLeadMoradaDescricao] = useState('');
    const [leadMoradaEmail, setLeadMoradaEmail] = useState('');
    const [leadMoradaEnderecoDefeito, setLeadMoradaEnderecoDefeito] = useState(false);

    // Listas de opções
    const [paises, setPaises] = useState([]);
    const [optionsStatus, setOptionsStatus] = useState([]);

    const [optionsCategoria, setOptionsCategoria] = useState([]);
    const [optionsMarca, setOptionsMarca] = useState([]);
    const [optionsNacionaisInternacionais, setOptionsNacionaisInternacionais] = useState([]);
    const [optionsTipo, setOptionsTipo] = useState([]);
    const [optionsModelo, setOptionsModelo] = useState([]);
    const [optionsCortesia, setOptionsCortesia] = useState([]);
    const [optionsFuncao, setOptionsFuncao] = useState([]);
    const [optionsOrigem, setOptionsOrigem] = useState([]);
    const [optionsInteresse, setOptionsInteresse] = useState([]);
    const [optionsRepresentante, setOptionsRepresentante] = useState([]);
    const [optionsMoeda, setOptionsMoeda] = useState([]);
    const [optionsLingua, setOptionsLingua] = useState([]);

    // Loadings
    const [loading, setLoading] = useState(false);

    // Mensagens de erros de campos
    const [msgErroCortesia, setMsgErroCortesia] = useState('');
    const [msgErroApelido, setMsgErroApelido] = useState('');
    const [msgErroRazaoSocial, setMsgErroRazaoSocial] = useState('');
    const [msgErroNome, setMsgErroNome] = useState('');
    const [msgErroCategoria, setMsgErroCategoria] = useState('');
    const [msgErroTelemovel, setMsgErroTelemovel] = useState('');
    const [msgErroEmail, setMsgErroEmail] = useState('');
    const [msgErroContribuinte, setMsgErroContribuinte] = useState('');
    const [msgErroMoeda, setMsgErroMoeda] = useState('');
    const [msgErroLingua, setMsgErroLingua] = useState('');
    const [msgErroOrigem, setMsgErroOrigem] = useState('');
    const [msgErroStatus, setMsgErroStatus] = useState('');
    const [msgErroInteresse, setMsgErroInteresse] = useState('');
    const [msgErroFollowUp, setMsgErroFollowUp] = useState('');
    const [msgErroMarca, setMsgErroMarca] = useState('');
    const [msgErroTipo, setMsgErroTipo] = useState('');
    const [msgErroModelo, setMsgErroModelo] = useState('');
    const [msgErroNacionalInternacional, setMsgErroNacionalInternacional] = useState('');
    const [msgErroRepresentante, setMsgErroRepresentante] = useState('');
    const [msgErroMoradas, setMsgErroMoradas] = useState('');

    const [showExitModal, setShowExitModal] = useState(false);
    const [loadingM, setLoadingM] = useState(false);

    // Criar una nova conta apartir do Lead
    function pushCliente() {
        history.push(`Prospects?lead=${leadSelecionado.value}`, lead);
        history.push(`Prospects`, {lead: lead});
    }
    useEffect(() => {
        if (novaConta && lead) {
            pushCliente();
            setNovaConta(false);
        }
    }, [novaConta, lead]);

    const handleLeavePage = event => {
        debugger;
        if (onChangeForm) {
            setShowExitModal(true);
            if (event?.preventDefault) {
                event?.preventDefault();
            }
            return false;
        }
        return true;
    };

    useEffect(() => {
        const unblock = history.block(handleLeavePage);

        window.addEventListener('beforeunload', handleLeavePage);

        return () => {
            unblock();
            window.removeEventListener('beforeunload', handleLeavePage);
        };
    }, [onChangeForm]);

    // Criar uma nova reunião apartir do Lead
    function pushReuniaoVisita() {
        history.push(`Agendamentos`, {lead: lead});
    }
    useEffect(() => {
        if (novaReuniaoVisita && lead) {
            pushReuniaoVisita();
            setNovaReuniaoVisita(false);
        }
    }, [novaReuniaoVisita, lead]);

    const [freeze, setFreeze] = useState(false);

    async function GravarLead() {
        var podeGravar = true;
        setLoadingM(true)
        setMsgErroCortesia('');
        setMsgErroApelido('');
        setMsgErroRazaoSocial('');
        setMsgErroNome('');
        setMsgErroCategoria('');
        setMsgErroTelemovel('');
        setMsgErroEmail('');
        setMsgErroContribuinte('');
        setMsgErroMoeda('');
        setMsgErroLingua('');
        setMsgErroOrigem('');
        setMsgErroStatus('');
        setMsgErroInteresse('');
        setMsgErroFollowUp('');
        setMsgErroMarca('');
        setMsgErroNacionalInternacional('');
        setMsgErroTipo('');
        setMsgErroModelo('');
        setMsgErroRepresentante('');
        setMsgErroMoradas('');

        if (!leadCortesia) {
            setMsgErroCortesia(t('insiraCortesia'));
            podeGravar = false;
        }
        if (!leadApelido) {
            setMsgErroApelido(t('insiraApelido'));
            podeGravar = false;
        }
        // if (!leadRazaoSocial) {
        //     setMsgErroRazaoSocial(t('insiraRazaoSocial'));
        //     podeGravar = false;
        // }
        if (!leadNome) {
            setMsgErroNome(t('insiraNome'));
            podeGravar = false;
        }
        if (!leadCategoria) {
            setMsgErroCategoria(t('insiraCategoria'));
            podeGravar = false;
        }
        if (!leadTelemovel) {
            setMsgErroTelemovel(t('insiraTelemovel'));
            podeGravar = false;
        }
        // if (!leadMoeda) {
        //     setMsgErroMoeda(t('insiraMoeda'));
        //     podeGravar = false;
        // }

        if (!leadOrigem) {
            setMsgErroOrigem(t('insiraOrigem'));
            podeGravar = false;
        }
        // if (!leadStatus) {
        //     setMsgErroStatus(t('insiraStatus'));
        //     podeGravar = false;
        // }
        if (leadStatus?.value === 5 && !leadFollowUp.startDate) {
            setMsgErroFollowUp(t('insiraFollowUp'));
            podeGravar = false;
        }
        // if (!leadTipo) {
        //     setMsgErroTipo(t('insiraTipo'));
        //     podeGravar = false;
        // }
        // if (!leadInteresse) {
        //     setMsgErroInteresse(t('insiraInteresse'));
        //     podeGravar = false;
        // }

        if (leadMoradas.filter(m => m.id !== '').length === 0) {
            setMsgErroMoradas(t('insiraMoradas'));
            toast.warn(t('insiraEndereco2'), {
                position: 'top-right',
                autoClose: 6000,
            });
            podeGravar = false;
        }

        if (podeGravar === false) {
            setLoadingM(false)
            return;
        }

        const l = {
            codigo: leadSelecionado?.codigo ?? '',
            cortesia: leadCortesia,
            nome: leadNome,
            apelido: leadApelido,
            razaoSocial: leadRazaoSocial,
            representante: leadRepresentante,
            status: leadStatus,
            interesse: leadInteresse,
            followUp: leadFollowUp.startDate ? moment(leadFollowUp.startDate).format('YYYY-MM-DD') : null,
            categoria: leadCategoria,
            marca: leadMarca,
            nacionalInternacional: leadNacionalInternacional,
            tipo: leadTipo,
            modelo: leadModelo,
            origem: leadOrigem,
            contribuinte: leadNIF,
            // pais: 'string',
            // paisDescricao: 'string',
            comentario: leadComentario,
            telemovel: leadTelemovel,
            email: leadEmail,
            // moeda: leadMoeda,
            funcao: leadFuncao,
            lingua: leadLingua,
            moradas: leadMoradas
                .filter(m => m.id !== '')
                .map(m => {
                    return {
                        id: m.id,
                        morada: m.morada,
                        descricao: m.descricao,
                        codigoPostal: m.codigoPostal,
                        cidade: m.cidade,
                        contacto: m.contacto,
                        email: m.email,
                        pais: m.pais,
                        enderecoDefeito: m.enderecoDefeito,
                    };
                }),
        };

        const guardarConclusaoWS = new Promise((resolve, reject) => {
            gravarLead(l, lang)
                .then(res => {
                    if (res.data.success == true) {
                       
                        resolve('Sucesso!');
                    } else {
                        let mensagem = res.data.errorMessages;
                        let resposta = '';
                        if (mensagem) resposta = mensagem;
                        if (!mensagem) resposta = t('toastErro');
                        reject(resposta);
                    }
                })
                .catch(() => reject(t('toastErroServidor'), setFreeze(false)));
        });
        toast.promise(
            guardarConclusaoWS,
            {
                success: {
                    render({data}) {
                        setShowForm(false);
                        setEditarLead(false);
                        setLoadingM(false)
                        return t('leadCriado');
                    },
                },
                // pending: t('a_guardar'),
                error: {
                    render({data}) {
                        setLoadingM(false)
                        return data;
                    },
                },
            },
            {autoClose: 2000},
        );
        // para poder alterar states de qualquer coisa tenho que ter a promise concluida, senão o toast nunca desaparece
        // por isso tenho de fazer um await
        await Promise.allSettled([guardarConclusaoWS]);
    }

    useEffect(async () => {
        if (guardarLead) {
            await GravarLead();
            setGuardarLead(false);
        }
    }, [guardarLead]);

    useEffect(() => {
        setLoading(false);
        var promises = [];
        promises.push(
            getCategoriasArtigos(lang).then(res => {
                if (res.data.success) {
                    setOptionsCategoria(res.data.categorias);
                }
            }),
        );
        promises.push(
            getMarcas(lang).then(res => {
                if (res.data.success) {
                    setOptionsMarca(res.data.marcas);
                }
            }),
        );

        promises.push(
            getNacionaisInternacionais(lang).then(res => {
                if (res.data.success) {
                    setOptionsNacionaisInternacionais(res.data.nacionaisInternacionais);
                }
            }),
        );

        promises.push(
            getTipos(lang).then(res => {
                if (res.data.success) {
                    setOptionsTipo(res.data.tipos);
                }
            }),
        );

        promises.push(
            getModelos(lang).then(res => {
                if (res.data.success) {
                    setOptionsModelo(res.data.modelos);
                }
            }),
        );

        promises.push(
            getLeadStatus(lang).then(res => {
                if (res.data.success) {
                    setOptionsStatus(res.data.status);
                }
            }),
        );

        promises.push(
            getPaises(lang).then(res => {
                if (res.data.success) {
                    setPaises(res.data.paises);
                }
            }),
        );

        promises.push(
            getCortesias(lang).then(res => {
                if (res.data.success) {
                    setOptionsCortesia(res.data.cortesias);
                }
            }),
        );

        promises.push(
            getFuncoes(lang).then(res => {
                if (res.data.success) {
                    setOptionsFuncao(res.data.funcoes);
                }
            }),
        );

        promises.push(
            getOrigens(lang).then(res => {
                if (res.data.success) {
                    setOptionsOrigem(res.data.origens);
                }
            }),
        );

        promises.push(
            getInteresses(lang).then(res => {
                if (res.data.success) {
                    setOptionsInteresse(res.data.interesses);
                }
            }),
        );

        promises.push(
            getRepresentantes(lang).then(res => {
                if (res.data.success) {
                    setOptionsRepresentante(res.data.representantes);
                }
            }),
        );

        promises.push(
            getMoedas(lang).then(res => {
                if (res.data.success) {
                    setOptionsMoeda(res.data.moedas);
                }
            }),
        );

        promises.push(
            getLinguas(lang).then(res => {
                if (res.data.success) {
                    setOptionsLingua(res.data.linguas);
                }
            }),
        );

        Promise.all(promises).finally(() => {
            setLoading(false);
        });
    }, []);

    useEffect(() => {
        if (lead) {
            setLeadCortesia(lead?.cortesia);
            setLeadNome(lead?.nome);
            setLeadApelido(lead?.apelido);
            setLeadRazaoSocial(lead?.razaoSocial);
            setLeadFuncao(lead?.funcao);
            setLeadTelemovel(lead?.telemovel);
            setLeadEmail(lead?.email);
            setLeadNIF(lead?.contribuinte);
            // setLeadMoeda(lead?.moeda);
            setLeadLingua(lead?.lingua);

            setLeadOrigem(lead?.origem);
            setLeadStatus(lead?.status);
            setLeadInteresse(lead?.interesse);
            setLeadFollowUp({
                startDate: lead?.followUp ? moment(lead?.followUp).format('YYYY-MM-DD') : null,
                endDate: lead?.followUp ? moment(lead?.followUp).format('YYYY-MM-DD') : null,
            });

            setLeadCategoria(lead?.categoria);
            setLeadMarca(lead?.marca);
            setLeadNacionalInternacional(lead?.nacionalInternacional);
            setLeadTipo(lead?.tipo);
            setLeadModelo(lead?.modelo);

            setLeadRepresentante(lead?.representante);
            setLeadMoradas([
                ...(lead?.moradas ?? []),
                {
                    id: '',
                    pais: null,
                    morada: '',
                    codigoPostal: '',
                    cidade: '',
                    enderecoDefeito: false,
                    descricao: '',
                },
            ]);

            setLeadComentario(lead?.comentario);
        }
    }, [lead]);

    useEffect(() => {
        if (leadSelecionado) {
            setLoading(true);
            getLead(leadSelecionado.value, lang)
                .then(res => {
                    if (res.data.success) {
                        setLead(res.data.lead);
                    } else {
                    }
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    }, [leadSelecionado]);

    return (
        <div id="myTabContent">
            {loading && (
                <div className="flex flex-row mt-14 justify-center">
                    <>
                        <Spinner />
                    </>
                </div>
            )}
            {loadingM && <LoadingModal />}
            {!loading && (
                <form>
                    <div className={openTab === 1 ? 'block' : 'hidden'} id="link1">
                        <Detalhes
                            info={{
                                optionsCortesia,

                                optionsFuncao,
                                optionsOrigem,
                                optionsInteresse,

                                optionsStatus,
                                optionsCategoria,
                                optionsMarca,
                                optionsNacionaisInternacionais,
                                optionsTipo,
                                optionsModelo,

                                optionsRepresentante,

                                optionsMoeda,
                                optionsLingua,

                                leadCortesia,
                                setLeadCortesia,
                                leadNome,
                                setLeadNome,
                                leadApelido,
                                setLeadApelido,
                                leadRazaoSocial,
                                setLeadRazaoSocial,
                                leadFuncao,
                                setLeadFuncao,
                                leadTelemovel,
                                setLeadTelemovel,
                                leadEmail,
                                setLeadEmail,
                                leadNIF,
                                setLeadNIF,
                                leadOrigem,
                                setLeadOrigem,
                                leadStatus,
                                setLeadStatus,
                                leadInteresse,
                                setLeadInteresse,
                                leadFollowUp,
                                setLeadFollowUp,
                                leadCategoria,
                                setLeadCategoria,
                                leadMarca,
                                setLeadMarca,
                                leadNacionalInternacional,
                                setLeadNacionalInternacional,
                                leadTipo,
                                setLeadTipo,
                                leadModelo,
                                setLeadModelo,
                                leadRepresentante,
                                setLeadRepresentante,

                                // leadMoeda,
                                // setLeadMoeda,
                                leadLingua,
                                setLeadLingua,

                                leadComentario,
                                setLeadComentario,

                                editarLead,

                                msgErroCortesia,
                                msgErroApelido,
                                msgErroRazaoSocial,
                                msgErroNome,
                                msgErroCategoria,
                                msgErroTelemovel,
                                msgErroEmail,
                                msgErroContribuinte,
                                msgErroMoeda,
                                msgErroLingua,
                                msgErroOrigem,
                                msgErroStatus,
                                msgErroInteresse,
                                msgErroFollowUp,
                                msgErroMarca,
                                msgErroNacionalInternacional,
                                msgErroTipo,
                                msgErroModelo,
                                msgErroRepresentante,

                                setMsgErroCortesia,
                                setMsgErroApelido,
                                setMsgErroRazaoSocial,
                                setMsgErroNome,
                                setMsgErroCategoria,
                                setMsgErroTelemovel,
                                setMsgErroEmail,
                                setMsgErroContribuinte,
                                setMsgErroMoeda,
                                setMsgErroLingua,
                                setMsgErroOrigem,
                                setMsgErroStatus,
                                setMsgErroInteresse,
                                setMsgErroFollowUp,
                                setMsgErroMarca,
                                setMsgErroNacionalInternacional,
                                setMsgErroTipo,
                                setMsgErroModelo,
                                setMsgErroRepresentante,
                                //
                                leadMoradas,
                                setLeadMoradas,
                                setOnChangeForm,
                                leadMoradaID,
                                setLeadMoradaID,
                                leadMoradaPais,
                                setLeadMoradaPais,
                                leadMoradaMorada,
                                setLeadMoradaMorada,
                                leadMoradaCodigoPostal,
                                setLeadMoradaCodigoPostal,
                                leadMoradaCidade,
                                setLeadMoradaCidade,
                                leadMoradaContacto,
                                setLeadMoradaContacto,
                                leadMoradaDescricao,
                                setLeadMoradaDescricao,
                                leadMoradaEmail,
                                setLeadMoradaEmail,
                                leadMoradaEnderecoDefeito,
                                setLeadMoradaEnderecoDefeito,
                                paises,
                            }}
                        />
                    </div>
                    {openTab === 2 && (
                        <div className={openTab === 2 ? 'block' : 'hidden'} id="link2">
                            <Endereco
                                info={{
                                    paises,

                                    leadMoradas,
                                    setLeadMoradas,

                                    leadMoradaID,
                                    setLeadMoradaID,
                                    leadMoradaPais,
                                    setLeadMoradaPais,
                                    leadMoradaMorada,
                                    setLeadMoradaMorada,
                                    leadMoradaCodigoPostal,
                                    setLeadMoradaCodigoPostal,
                                    leadMoradaCidade,
                                    setLeadMoradaCidade,
                                    leadMoradaContacto,
                                    setLeadMoradaContacto,
                                    leadMoradaDescricao,
                                    setLeadMoradaDescricao,
                                    leadMoradaEmail,
                                    setLeadMoradaEmail,
                                    leadMoradaEnderecoDefeito,
                                    setLeadMoradaEnderecoDefeito,

                                    editarLead,

                                    msgErroMoradas,
                                    setMsgErroMoradas,
                                    //
                                    setOnChangeForm,
                                }}
                            />
                        </div>
                    )}
                </form>
            )}
            <ToastContainer />
            {showExitModal && (
                <ExitForm
                    cancelar={() => setShowExitModal(false)}
                    back={() => {
                        setShowForm(false);
                        setShowExitModal(false);
                        setEditarLead(false);
                    }}
                />
            )}
        </div>
    );
}
